"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _WireObject2 = _interopRequireDefault(require("../WireObject"));

var _creative = require("../../constants/creative");

var _isEmptyString = _interopRequireDefault(require("../../utils/object/isEmptyString"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _removeUnusedKeys = _interopRequireDefault(require("../../utils/object/removeUnusedKeys"));

var _getGuid = _interopRequireDefault(require("../../utils/guid/getGuid"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CreativeDocumentMedium = /*#__PURE__*/function (_WireObject) {
  (0, _inherits2["default"])(CreativeDocumentMedium, _WireObject);

  var _super = _createSuper(CreativeDocumentMedium);

  /**
   * Media Entity Id from DataStore for the audio file associated with this media object (video only)
   */

  /**
   * Duration in seconds of the audio stream for video media
   */

  /**
   * Start time in seconds of the audio stream for video media
   */

  /**
   * X coodinate (medium-relative) of the most salient point of the media (image only)
   */

  /**
   * Duration in seconds of the media (audio, video)
   */

  /**
   * File name of the media
   */

  /**
   * DEPRECATED - value used to adjust padding of text within an SVG before overflow was enabled. No longer needed.
   */

  /**
   * The file format that the server can use to process this media, currently PNG or JPG
   */

  /**
   * Boolean indicating whether or not this media is used within a template and needs to be replaced. Used along with templateId
   */

  /**
   * Height in pixels of the media (video, image, inlinesvg)
   */

  /**
   * Boolean indicating if the media has been loaded on the users's local machine.
   */

  /**
   * String (or blob) url from the user's local machine we can use as the url while the media is uploading.
   */

  /**
   * String ID of the media, used in the media list and map in the creative document. Referenced by Content.
   */

  /**
   * String media type value which is one from MEDIA_TYPE constant.
   */

  /**
   * Mime type of media file, when applicable.
   */

  /**
   * Boolean indicating that the audio for this media has been processed (video, audio)
   */

  /**
   * List of processors
   */

  /**
   * String ID pointing to the Media Entity in DataStore that represents this media. (not inlinesvg)
   */

  /**
   * String value indicating the source of the media, either empty or from MEDIA_SOURCE constant
   */

  /**
   * In the case of mediaType INLINE_SVG - the SVG contents for this media. (inlinesvg)
   */

  /**
   * String template ID representing the template this media object was copied from. Used with fromTemplate
   */

  /**
   * Boolean indicating that the server has indicated that the upload process is complete and that the media is available via remote URL.
   */

  /**
   * Boolean indicating that the user's machine has finished sending the bytes for this media
   */

  /**
   * Number showing percentage of upload that has been complete from user's machine.
   */

  /**
   * Boolean indicating that an upload has failed.
   */

  /**
   * Remote URL (usually relative to the server) of the media
   */

  /**
   * Boolean indicating if the PNG sequence should be used for client preview
   */

  /**
   * List of media variants, typically for video, that can also be used in preview or building (video)
   */

  /**
   * Width in pixels of the media (video, image, inlinesvg)
   */

  /**
   * @param {String} mediaType - Content type from the CONTENT_TYPE constant.
   * @param {String|null} mediaId - ID fo the content, if not supplied a new one will be generated.
   */
  function CreativeDocumentMedium(mediaType) {
    var _this;

    var mediaId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck2["default"])(this, CreativeDocumentMedium);

    if ((0, _isEmptyString["default"])(mediaType) || (0, _isNil["default"])(_creative.MEDIA_TYPE[mediaType.toUpperCase()])) {
      throw new Error("CreativeDocumentMedium must have a valid mediaType: ".concat(mediaType));
    }

    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_audioServerId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_audioStreamDuration", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_audioStreamStartTime", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_centerX", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_duration", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fileName", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fontAdjustment", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_frameFormat", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fromTemplate", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_height", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_loaded", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_localUrl", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_mediaId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_mediaType", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_mimeType", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_processedAudio", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_processors", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_serverId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_source", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_svg", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_templateId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_uploadComplete", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_uploaded", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_uploadedPercent", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_uploadFailed", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_url", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_usePngSequence", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_variants", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_width", void 0);
    _this._mediaType = mediaType.toUpperCase();
    _this._mediaId = (0, _isEmptyString["default"])(mediaId) ? CreativeDocumentMedium.getId() : mediaId;
    _this._mediaType = mediaType;
    _this._mediaId = mediaId;
    return _this;
  }

  (0, _createClass2["default"])(CreativeDocumentMedium, [{
    key: "copy",
    value: function copy() {
      var json = this.toJSON();
      return CreativeDocumentMedium.fromJSON(json);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var mediumObj = {
        audioServerId: this.audioServerId,
        audioStreamDuration: this.audioStreamDuration,
        audioStreamStartTime: this.audioStreamStartTime,
        centerX: this.centerX,
        duration: this.duration,
        fileName: this.fileName,
        fontAdjustment: this.fontAdjustment,
        frameFormat: this.frameFormat,
        fromTemplate: this.fromTemplate,
        height: this.height,
        loaded: this.loaded,
        localUrl: this.localUrl,
        mediaId: this.mediaId,
        mediaType: this.mediaType,
        mimeType: this.mimeType,
        processedAudio: this.processedAudio,
        processors: this.processors,
        serverId: this.serverId,
        source: this.source,
        svg: this.svg,
        templateId: this.templateId,
        uploadComplete: this.uploadComplete,
        uploaded: this.uploaded,
        uploadedPercent: this.uploadedPercent,
        uploadFailed: this.uploadFailed,
        url: this.url,
        usePngSequence: this.usePngSequence,
        variants: this.variants,
        width: this.width
      };
      return (0, _removeUnusedKeys["default"])(mediumObj);
    }
  }, {
    key: "audioServerId",
    get: function get() {
      return this._audioServerId;
    },
    set: function set(value) {
      this._audioServerId = value;
    }
  }, {
    key: "audioStreamDuration",
    get: function get() {
      return this._audioStreamDuration;
    },
    set: function set(value) {
      this._audioStreamDuration = value;
    }
  }, {
    key: "audioStreamStartTime",
    get: function get() {
      return this._audioStreamStartTime;
    },
    set: function set(value) {
      this._audioStreamStartTime = value;
    }
  }, {
    key: "centerX",
    get: function get() {
      return this._centerX;
    },
    set: function set(value) {
      this._centerX = value;
    }
  }, {
    key: "duration",
    get: function get() {
      return this._duration;
    },
    set: function set(value) {
      this._duration = value;
    }
  }, {
    key: "fileName",
    get: function get() {
      return this._fileName;
    },
    set: function set(value) {
      this._fileName = value;
    }
  }, {
    key: "fontAdjustment",
    get: function get() {
      return this._fontAdjustment;
    },
    set: function set(value) {
      this._fontAdjustment = value;
    }
  }, {
    key: "frameFormat",
    get: function get() {
      return this._frameFormat;
    },
    set: function set(value) {
      this._frameFormat = value;
    }
  }, {
    key: "fromTemplate",
    get: function get() {
      return this._fromTemplate;
    },
    set: function set(value) {
      this._fromTemplate = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      this._height = value;
    }
  }, {
    key: "loaded",
    get: function get() {
      return this._loaded;
    },
    set: function set(value) {
      this._loaded = value;
    }
  }, {
    key: "localUrl",
    get: function get() {
      return this._localUrl;
    },
    set: function set(value) {
      this._localUrl = value;
    }
  }, {
    key: "mediaId",
    get: function get() {
      return this._mediaId;
    },
    set: function set(value) {
      this._mediaId = value;
    }
  }, {
    key: "mediaType",
    get: function get() {
      return this._mediaType;
    },
    set: function set(value) {
      this._mediaType = value;
    }
  }, {
    key: "mimeType",
    get: function get() {
      return this._mimeType;
    },
    set: function set(value) {
      this._mimeType = value;
    }
  }, {
    key: "processedAudio",
    get: function get() {
      return this._processedAudio;
    },
    set: function set(value) {
      this._processedAudio = value;
    }
  }, {
    key: "processors",
    get: function get() {
      return this._processors;
    },
    set: function set(value) {
      this._processors = value;
    }
  }, {
    key: "serverId",
    get: function get() {
      return this._serverId;
    },
    set: function set(value) {
      this._serverId = value;
    }
  }, {
    key: "source",
    get: function get() {
      return this._source;
    },
    set: function set(value) {
      this._source = value;
    }
  }, {
    key: "svg",
    get: function get() {
      return this._svg;
    },
    set: function set(value) {
      this._svg = value;
    }
  }, {
    key: "templateId",
    get: function get() {
      return this._templateId;
    },
    set: function set(value) {
      this._templateId = value;
    }
  }, {
    key: "uploadComplete",
    get: function get() {
      return this._uploadComplete;
    },
    set: function set(value) {
      this._uploadComplete = value;
    }
  }, {
    key: "uploaded",
    get: function get() {
      return this._uploaded;
    },
    set: function set(value) {
      this._uploaded = value;
    }
  }, {
    key: "uploadedPercent",
    get: function get() {
      return this._uploadedPercent;
    },
    set: function set(value) {
      this._uploadedPercent = value;
    }
  }, {
    key: "uploadFailed",
    get: function get() {
      return this._uploadFailed;
    },
    set: function set(value) {
      this._uploadFailed = value;
    }
  }, {
    key: "url",
    get: function get() {
      return this._url;
    },
    set: function set(value) {
      this._url = value;
    }
  }, {
    key: "usePngSequence",
    get: function get() {
      return this._usePngSequence;
    },
    set: function set(value) {
      this._usePngSequence = value;
    }
  }, {
    key: "variants",
    get: function get() {
      return this._variants;
    },
    set: function set(value) {
      this._variants = value;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      this._width = value;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(inMediaJSON) {
      if ((0, _isNil["default"])(inMediaJSON)) return null;
      var audioServerId = inMediaJSON.audioServerId,
          audioStreamDuration = inMediaJSON.audioStreamDuration,
          audioStreamStartTime = inMediaJSON.audioStreamStartTime,
          centerX = inMediaJSON.centerX,
          duration = inMediaJSON.duration,
          fileName = inMediaJSON.fileName,
          fontAdjustment = inMediaJSON.fontAdjustment,
          frameFormat = inMediaJSON.frameFormat,
          fromTemplate = inMediaJSON.fromTemplate,
          height = inMediaJSON.height,
          loaded = inMediaJSON.loaded,
          localUrl = inMediaJSON.localUrl,
          mediaId = inMediaJSON.mediaId,
          mediaType = inMediaJSON.mediaType,
          mimeType = inMediaJSON.mimeType,
          processedAudio = inMediaJSON.processedAudio,
          processors = inMediaJSON.processors,
          serverId = inMediaJSON.serverId,
          source = inMediaJSON.source,
          svg = inMediaJSON.svg,
          templateId = inMediaJSON.templateId,
          uploadComplete = inMediaJSON.uploadComplete,
          uploaded = inMediaJSON.uploaded,
          uploadedPercent = inMediaJSON.uploadedPercent,
          uploadFailed = inMediaJSON.uploadFailed,
          url = inMediaJSON.url,
          usePngSequence = inMediaJSON.usePngSequence,
          variants = inMediaJSON.variants,
          width = inMediaJSON.width;
      var creativeDocumentMedium = new CreativeDocumentMedium(mediaType, mediaId);
      creativeDocumentMedium.audioServerId = audioServerId;
      creativeDocumentMedium.audioStreamDuration = audioStreamDuration;
      creativeDocumentMedium.audioStreamStartTime = audioStreamStartTime;
      creativeDocumentMedium.centerX = centerX;
      creativeDocumentMedium.duration = duration;
      creativeDocumentMedium.fileName = fileName;
      creativeDocumentMedium.fontAdjustment = fontAdjustment;
      creativeDocumentMedium.frameFormat = frameFormat;
      creativeDocumentMedium.fromTemplate = fromTemplate;
      creativeDocumentMedium.height = height;
      creativeDocumentMedium.loaded = loaded;
      creativeDocumentMedium.localUrl = localUrl;
      creativeDocumentMedium.mimeType = mimeType;
      creativeDocumentMedium.processedAudio = processedAudio;
      creativeDocumentMedium.processors = processors;
      creativeDocumentMedium.serverId = serverId;
      creativeDocumentMedium.source = source;
      creativeDocumentMedium.svg = svg;
      creativeDocumentMedium.templateId = templateId;
      creativeDocumentMedium.uploadComplete = uploadComplete;
      creativeDocumentMedium.uploaded = uploaded;
      creativeDocumentMedium.uploadedPercent = uploadedPercent;
      creativeDocumentMedium.uploadFailed = uploadFailed;
      creativeDocumentMedium.url = url;
      creativeDocumentMedium.usePngSequence = usePngSequence;
      creativeDocumentMedium.variants = (0, _deepCopy["default"])(variants);
      creativeDocumentMedium.width = width;
      return creativeDocumentMedium;
    }
  }, {
    key: "getId",
    value: function getId() {
      return "media-".concat((0, _getGuid["default"])());
    }
  }]);
  return CreativeDocumentMedium;
}(_WireObject2["default"]);

exports["default"] = CreativeDocumentMedium;